import React from 'react';
import { makeStyles } from 'tss-react/mui';

import { useIntl } from 'ha/i18n';
import { Box, Typography, Grid, units } from '@hbf/dsl';
import { PhoneActionsRing } from '@hbf/icons/custom';
import { SmartTrack as Track } from 'ha/components/track/SmartTrack';
import { Link } from 'ha/ui.legacy/Link';

import SpainIcon from 'ha/img-src/contact-us/Spain.png';
import BelgiumIcon from 'ha/img-src/contact-us/Belgium.png';
import FranceIcon from 'ha/img-src/contact-us/France.png';
import GermanyIcon from 'ha/img-src/contact-us/Germany.png';
import ItalyIcon from 'ha/img-src/contact-us/Italy.png';
import NetherlandIcon from 'ha/img-src/contact-us/Netherlands.png';
import UnitedKingdomIcon from 'ha/img-src/contact-us/United Kingdom.png';
import UnitedStatesIcon from 'ha/img-src/contact-us/United states.png';

const useStyles = makeStyles()(theme => ({
  helperText: {
    color: theme.palette.grey[500],
    textAlign: 'justify',
  },
  icon: {
    marginBottom: theme.spacing(2),
  },
  phoneItem: {
    marginBottom: theme.spacing(2),
  },
  link: {
    marginLeft: theme.spacing(1),
    color: theme.palette.secondary.main,
  },
  image: {
    width: units.rem(1.3),
    marginRight: theme.spacing(1),
  },
}));

export const PhoneBook: React.FC = () => {
  const { classes } = useStyles();
  const { T } = useIntl();

  const phones = [
    { name: T('Netherlands'), phone: T('NL CS phone'), icon: NetherlandIcon },
    { name: T('UK'), phone: T('UK CS phone'), icon: UnitedKingdomIcon },
    { name: T('US'), phone: T('US CS phone'), icon: UnitedStatesIcon },
    { name: T('Germany'), phone: T('DE CS phone'), icon: GermanyIcon },
    { name: T('Italy'), phone: T('IT CS phone'), icon: ItalyIcon },
    { name: T('Spain'), phone: T('ES CS phone'), icon: SpainIcon },
    { name: T('France'), phone: T('FR CS phone'), icon: FranceIcon },
    { name: T('Belgium'), phone: T('BE CS phone'), icon: BelgiumIcon },
  ];

  return (
    <Grid
      container
      direction="column"
      alignItems="center"
      justifyContent="center"
    >
      <Grid item>
        <PhoneActionsRing fontSize="large" className={classes.icon} />
      </Grid>
      <Grid item>
        {phones.map(({ name, phone, icon }) => (
          <Grid
            container
            alignItems="center"
            className={classes.phoneItem}
            data-test-locator={name}
            key={name}
          >
            <img src={icon} className={classes.image} alt="" />

            <Box display="flex" flexWrap="wrap">
              <Typography.Paragraph component="span">
                {name}
              </Typography.Paragraph>
              <Track name="Clicked Aircall" type="button">
                <Link
                  to={`tel:${phone}`}
                  className={classes.link}
                  skipLangFormat
                >
                  {phone}
                </Link>
              </Track>
            </Box>
          </Grid>
        ))}

        <Typography.HelperText className={classes.helperText}>
          {T(
            '*Calls to HousingAnywhere may incur additional charges from a mobile or from a country outside the regions listed. Please check with your provider for call costs.',
          )}
        </Typography.HelperText>
      </Grid>
    </Grid>
  );
};
